(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //

  function pxSetupSelectSite(
    NetworkListService, $timeout, $filter, $http, SitesProviderService
  ) {
    return {
      restrict: 'EA',
      scope: {
        onlyUploadConfiguration: '=onlyUploadConfiguration',
        paginationObject: '=paginationObject',
        tenant: '=tenant',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/setupSelectSite/setupSelectSite.template.html',
      link: function (scope) {

        let scrollEnd = null;
        let containerHeight = null;
        scope.searchString = '';

        (function () {
          setPosition();
          getFirstPage();
        })();

        function setPosition() {
          const element =  document.querySelector('.select-fake-list-float');
          const elementRatio = element.getBoundingClientRect();
          if ((elementRatio.bottom + 30) > window.innerHeight) {
            element.style.top = `-${elementRatio.bottom - window.innerHeight}px`;
          }
        }

        function getFirstPage() {
          scope.list = [];
          scope.paginationObject.pagingCriteria.page = 0;
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.loadingPage = true;
          SitesProviderService.getSitesPaged(scope.paginationObject, ['NETWORK'])
            .then(function (response) {
              window.scrollTo(0, 0);
              scope.totalPages = response.page.totalPages;
              if (response.sites) {
                scope.list = response.sites;
              }
              scope.loadingPage = false;
            })
            .catch(function () {
              scope.loadingPage = false;
            });
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          });
        };

        function getNextPage() {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.paginationObject.pagingCriteria.page += 1;
            scope.loadingPage = true;
            SitesProviderService.getSitesPaged(scope.paginationObject, ['NETWORK'])
              .then(function (response) {
                if (response.sites) {
                  scope.list = scope.list.concat(response.sites);
                }
                scope.loadingPage = false;
              })
              .catch(function () {
                scope.loadingPage = false;
              });
          }
        }

        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function () {
                getNextPage();
              }, 300);
            }
          }
        });

        scope.$on('$destroy', function () {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({ selectedItem });
        };

        scope.closePopup = function (event) {
          scope.callback({ selectItem: null });
        };

        // TOOLTIP STUFF

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'networkTooltip':
                networkTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function networkTooltip(position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'networkAllDetails',
            network: context
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 500 },
            contextMenu: false
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

      }
    };
  }

  pxSetupSelectSite.$inject = ['NetworkListService', '$timeout', '$filter', '$http', 'SitesProviderService'];

  angular
    .module('printix-admin')
    .directive('pxSetupSelectSite', pxSetupSelectSite);

})();
